// POSSO launch configuration.
// Edit this one file to change funnel options — no redesign needed.
// colours: id (unique key), name (shown to customer), klaviyo (canonical value
// stored in Klaviyo as preferred_pogo_colour — must match existing Klaviyo
// segments/data, e.g. the Lilac shoe is "Purple" in Klaviyo),
// hex (capsule fill), text (label colour on the colour).
// ring: true gives light colours a visible outline.
// To add/replace a colour (e.g. Turquoise), add an entry here — the colour
// question, hero capsules and success screen all update automatically.

export const POGO_COLOURS = [
  { id: "pink", name: "Pink", klaviyo: "Pink", hex: "#FF6BAA", text: "#111111" },
  { id: "yellow", name: "Yellow", klaviyo: "Yellow", hex: "#FFD84D", text: "#111111" },
  { id: "light-blue", name: "Light Blue", klaviyo: "Light Blue", hex: "#7CC9FF", text: "#111111" },
  { id: "lilac", name: "Lilac", klaviyo: "Purple", hex: "#C6A2FF", text: "#111111" },
  { id: "black", name: "Black", klaviyo: "Black", hex: "#111111", text: "#FFFFFF" },
];

// Colourways available to preorder right now (PDP + cart). Everything else
// shows "Coming soon" and routes to the notify banner.
export const PREORDER_COLOUR_IDS = ["pink", "black"];

// Supplied POSSO campaign imagery (4:5 portrait). Do not substitute.
export const HERO_IMAGE = {
  src: "/images/hero-campaign.webp",
  alt: "Three healthcare workers in scrubs wearing pink, yellow and light blue POSSO shoes",
};

export const POGO_LIFESTYLE = [
  {
    src: "/images/lifestyle-1.webp",
    alt: "Three nurses taking a mirror selfie wearing pink, yellow and light blue POSSO shoes",
  },
  {
    src: "/images/lifestyle-2.webp",
    alt: "Three nurses in scrubs wearing purple, coral and turquoise POSSO shoes",
  },
  {
    src: "/images/lifestyle-3.webp",
    alt: "Three nurses in scrubs wearing black, white and navy POSSO shoes",
  },
];

// Sizing — EU women's only. The stored value (pogo_shoe_size in Klaviyo) is
// prefix + size, e.g. "EU 38".
export const SIZE_GROUPS = [
  { key: "eu", label: "EU WOMEN'S", prefix: "EU ", sizes: ["35", "36", "37", "38", "39", "40", "41", "42"] },
];
export const SIZE_NOT_SURE = "Not sure / between sizes";

// Age ranges asked in Question 3. Stored as age_range in Klaviyo, exactly as shown.
export const AGE_RANGES = [
  "Under 20",
  "20–24",
  "25–29",
  "30–34",
  "35–39",
  "40–44",
  "45–49",
  "50+",
];
// Instagram shown after SMS opt-in.
export const INSTAGRAM_HANDLE = "@wear_posso";
export const INSTAGRAM_URL = "https://www.instagram.com/wear_posso";

// Product features shown on the hero. Edit freely. Claims policy: "made for
// long shifts" is fine — do NOT claim "12-hour comfort" or medical benefits.
export const POGO_FEATURES = [
  "NO-SLIP SOLE",
  "TOE PROTECTION",
  "MADE FOR LONG SHIFTS",
  "ACTUALLY FASHIONABLE",
];

// Contact shown in the Privacy Policy. Update to the real inbox before launch.
export const PRIVACY_EMAIL = "hello@wearposso.com.au";
